/** One Quality report: its filters live in the URL so a report can be bookmarked or shared. */
import {
  QUALITY_REPORT_PERMISSION,
  QUALITY_REPORTS,
  isQualityReportSlug,
  qualityReportKey,
} from "@nexseed/shared";
import { createFileRoute, redirect, useNavigate } from "@tanstack/react-router";
import { ListPageSkeleton } from "@/components/app/skeletons";
import { useAuth } from "@/features/auth/store";
import { useFacilities } from "@/features/auth/use-facilities";
import { PeriodReportPage } from "@/features/reports/period-report-page";
import { reportSearch } from "@/features/warehouse/reports/api";

export const Route = createFileRoute("/_app/reports/qc/$slug")({
  validateSearch: reportSearch,
  // Each report on its own tick under Roles → Reports → Quality alone (user, 2026-10-29).
  beforeLoad: ({ params }) => {
    const { can } = useAuth.getState();
    if (
      !isQualityReportSlug(params.slug) ||
      !can(QUALITY_REPORT_PERMISSION[params.slug])
    )
      throw redirect({ to: "/reports" });
  },
  component: Page,
});

function Page() {
  const { slug } = Route.useParams();
  const s = Route.useSearch();
  const navigate = useNavigate({ from: Route.fullPath });
  const { selected, ready } = useFacilities();
  if (!ready) return <ListPageSkeleton />;
  if (!isQualityReportSlug(slug)) return null;
  return (
    <PeriodReportPage
      key={slug}
      def={QUALITY_REPORTS[qualityReportKey(slug)]}
      path={`/reports/qc/${slug}`}
      fileName={`${slug}.xlsx`}
      facilityId={selected?.id}
      search={s}
      onSearch={(next) =>
        void navigate({ search: (prev) => ({ ...prev, ...next }) })
      }
    />
  );
}
